import {
  FieldContext,
  FieldOptions,
  FormContext as VeeFormContext,
  RuleExpression,
  useField as veeUseField,
  useForm as veeUseForm,
} from 'vee-validate';
import { MaybeRef, MaybeRefOrGetter } from 'vue';

export interface FormContext<T> {
  values: T;
  handleSubmit: VeeFormContext['handleSubmit'];
  setValues: VeeFormContext['setValues'];
  setFieldValue: VeeFormContext['setFieldValue'];
  errors: VeeFormContext['errors'];
}

export const useForm = <T>(): FormContext<T> => {
  const { values, handleSubmit, setValues, setFieldValue, errors } =
    veeUseForm();
  return {
    values: values as unknown as T,
    handleSubmit,
    setValues,
    setFieldValue,
    errors,
  };
};

export const useField = <T>(
  path: MaybeRefOrGetter<string>,
  rules?: MaybeRef<RuleExpression<T>>,
  opts?: Partial<FieldOptions<T>>,
): FieldContext<T> => {
  const context = veeUseField<T>(path, rules, opts);

  return context;
};
